import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

const faqs = [
  {
    question: 'What practice areas does SafeIdea support?',
    answer:
      'SafeIdea includes pre-built workflows for litigation, transactions, regulatory compliance, intellectual property, and general legal research. You can also create custom workflows to match your specific practice needs.',
  },
  {
    question: 'How is my client data protected?',
    answer:
      'SafeIdea is a native desktop application—all your work product stays on your local machine. When using cloud AI for complex analysis, our patent-pending deidentification layer strips identifying information before anything leaves your computer. Your original documents are never transmitted.',
  },
  {
    question: "What's the difference between local and cloud AI?",
    answer:
      'Local AI runs entirely on your computer with zero data transmission—ideal for highly sensitive work and offline use. Cloud AI (Claude from Anthropic) provides more advanced reasoning for complex analysis, accessed through our deidentification layer. You choose which to use for each task.',
  },
  {
    question: 'What are the system requirements?',
    answer:
      "SafeIdea runs on Windows 10/11 and macOS. For local AI capabilities, you'll need at least 32GB RAM with a dedicated GPU or Apple Silicon (M1/M2/M3). Cloud AI features work on any modern computer with an internet connection.",
  },
  {
    question: 'Is SafeIdea a multi-tenant cloud solution?',
    answer:
      'No. SafeIdea is a native desktop application installed on your machine. There is no shared cloud infrastructure, no multi-tenant database, and no way for your data to intermingle with other users. You maintain complete control.',
  },
  {
    question: 'How much will SafeIdea cost after beta?',
    answer:
      'We have not finalized pricing. Beta participants will receive advance notice and preferential terms when we launch commercially.',
  },
];

export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-20 sm:py-32 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="mx-auto mt-16 max-w-3xl">
          <div className="divide-y divide-gray-200">
            {faqs.map((faq, index) => (
              <div key={faq.question} className="py-6">
                <button
                  type="button"
                  className="flex w-full items-center justify-between text-left"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="text-lg font-medium text-gray-900">{faq.question}</span>
                  <ChevronDown
                    className={`h-5 w-5 text-gray-500 transition-transform ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                {openIndex === index && (
                  <p className="mt-4 text-gray-600 leading-relaxed">{faq.answer}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
